<template>
  <v-app id="app">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  mounted() {
    try {
      // Encriptar todo el mensaje en base64 y mostrarlo como warning
      const apiKey = process.env.VUE_APP_GOOGLE_API_KEY;
      if (apiKey) {
        const message = `Base64 Encoded API Key: ${apiKey}`;
        const encodedMessage = btoa(message);
        console.warn(encodedMessage);
      } else {
        const errorMessage = "VUE_APP_GOOGLE_API_KEY no está definida.";
        console.warn(btoa(errorMessage));
      }
    } catch (error) {
      const errorMessage = `Error al encriptar la API Key: ${error.message}`;
      console.error(btoa(errorMessage));
    }
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
#app {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  color: #37352f;
  /* Cambiar tamaño mínimo de letra */
  font-size: 16px;
}

::selection{
  background-color: #bdd6f0;
}

.custom-border-padding{
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 8px 16px 8px 16px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter {
  opacity: 0; /* Iniciar con opacidad 0 cuando entra */
}
.fade-enter-to {
  opacity: 1; /* Finalizar con opacidad 1 cuando entra */
}
.fade-leave-to {
  opacity: 0; /* Finalizar con opacidad 0 cuando se va */
}

input[type="text"], input[type="password"] {
  outline: none;
}

input:focus {
  outline: none;
}

/* Para navegadores basados en WebKit (Chrome, Safari) */
::-webkit-scrollbar {
  width: 8px; /* Ancho del scrollbar */
  height: 8px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1); /* Fondo semitransparente del track */
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.4); /* Color semitransparente del pulgar */
  border-radius: 4px; /* Bordes redondeados */
}

/* Para Firefox */
* {
  scrollbar-width: thin; /* Define un scrollbar delgado */
  scrollbar-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.1); /* Pulgar y track */
}


html, body {
  margin: 0;
  padding: 0;
  /* overflow: hidden; */
}

.vanta-bg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0; left: 0;
}

.no-user-select {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera, and Edge */
}

.center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.disabled{
  background-color: #f5f5f5;
  border: 1px solid #d6d6d6;
  opacity: 0.7;
  pointer-events: none;
}

</style>
